import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatDate(ts: number | null | undefined): string {
  if (!ts) return '—'
  return new Date(ts).toLocaleDateString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric' })
}

export function formatDateTime(ts: number | null | undefined): string {
  if (!ts) return '—'
  return new Date(ts).toLocaleString('ro-RO', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
}

export function formatCurrency(val: number | string | null | undefined, currency = 'RON'): string {
  if (val == null) return '—'
  const n = typeof val === 'string' ? parseFloat(val) : val
  return new Intl.NumberFormat('ro-RO', { style: 'currency', currency }).format(n)
}

// Validatorii de identificatori fiscali vin din @edrikom/shared — sursă unică pentru
// frontend și backend. Aici existau copii locale, iar cea din backend era un ciot
// care doar număra cifrele, deci cele două părți nu erau de acord.
export { valideazaCnp as validateCnp, valideazaCui as validateCui } from '@edrikom/shared'

export function secureFileUrl(path: string | null | undefined): string {
  if (!path) return ''
  // Preferăm token-ul de download restrâns (scope 'file') — ajunge în URL, deci în
  // loguri, dar NU dă acces la tRPC/sesiune. Fallback pe token-ul de sesiune doar cât
  // timp cel de download nu a fost încă emis (fereastră scurtă după login). Vezi C-sec2.
  const token = localStorage.getItem('fileToken') || localStorage.getItem('token')
  const filePath = path.replace(/^\/uploads\//, '/files/')
  return token ? `${filePath}?t=${token}` : path
}

export function humanizeError(msg: string | undefined | null): string {
  if (!msg) return 'A apărut o eroare neașteptată. Reîncercați.'
  const m = msg.toLowerCase()
  if (m === 'unauthorized' || m.includes('unauthorized'))        return 'Sesiunea a expirat. Deconectați-vă și reconectați-vă.'
  if (m.includes('foreign key constraint'))                      return 'Nu se poate șterge — există înregistrări asociate (contracte, facturi sau documente).'
  if (m.includes('unique constraint') && m.includes('cnp'))      return 'CNP-ul există deja în sistem.'
  if (m.includes('unique constraint') && m.includes('cui'))      return 'CUI-ul există deja în sistem.'
  if (m.includes('unique constraint'))                           return 'Există deja o înregistrare identică în sistem.'
  if (m.includes('not null constraint'))                         return 'Câmp obligatoriu lipsă — contactați suportul tehnic.'
  return msg
}
